module.exports = "/_next/static/videos/laptop-black-e6144ddc35cc65cebea7c0aca299c0f1.mp4";